// extracted by mini-css-extract-plugin
export default {"page":"layaout_page__mNGfR","container":"layaout_container__ExFCU","containerTitle":"layaout_containerTitle__aQMkZ","linear":"layaout_linear__dKeda","close":"layaout_close__Qo7Dx"};